import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import type { QuickInsertPlugin } from '@atlaskit/editor-plugin-quick-insert';

import { onCurrentFetchComplete } from '../store/snippetsStore.ts';

import { addSnippetQuickInsertItem } from './snippetQuickInsertItemApi.tsx';

/**
 * Registers a one-time callback to add snippets to the quick insert menu
 * when the current in-flight fetch completes.
 *
 * Call this when you have an editorAPI and want to ensure snippets are added
 * to quick insert even if the fetch was still in progress when the editor loaded.
 *
 * The caller is responsible for checking that snippets are currently loading
 * (isLoading=true && isLoaded=false) before calling this function.
 *
 * This is a no-op if editorAPI is not provided.
 *
 *  @param editorAPI - The editor API with QuickInsertPlugin
 */
export const registerSnippetsQuickInsertOnLoad = (
	editorAPI: PublicPluginAPI<[QuickInsertPlugin]> | null | undefined,
): void => {
	if (!editorAPI) {
		return;
	}

	onCurrentFetchComplete((loadedSnippets) => {
		loadedSnippets.forEach((snippet) => {
			addSnippetQuickInsertItem({ snippet, editorAPI });
		});
	});
};
